
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fansi-win",
      function () {
        return require("private-next-pages/fansi-win.tsx");
      }
    ]);
  